window.onload = () => {
  const countDownEl = document.getElementsByClassName("header-count-down")[0];

  initNavEvt();
  initSearchEvt();
  stopShelterEl();

  if (countDownEl) {
    initCountDown(countDownEl);
  }
};
//顶部导航栏
function initNavEvt() {
  const headerEl = document.getElementById("shopify-section-header");

  let tMenuEl = document.querySelector(".header__inline-menu .tmenu_nav");
  let supportEl = document.querySelector(
    ".header__inline-menu .headline-support"
  );
  let classifyEls = document.querySelectorAll(
    ".header__inline-menu .nav-product-classify"
  );
  //start hover产品分类

  classifyEls.forEach((classifyEl) => {
    classifyEl?.addEventListener("mouseenter", hoverClassify);
  });
  supportEl?.addEventListener("mouseenter", (e) => {
    const supportMoreEl = supportEl?.children[1];

    if (supportMoreEl) {
      let { paddingLeft } = getComputedStyle(tMenuEl?.firstChild?.firstChild);
      let { left, right } = tMenuEl?.getBoundingClientRect();
      right = document.body.clientWidth - right;

      if (
        supportEl?.lastChild?.lastChild.className.indexOf("tmenu-watermark") !==
        -1
      ) {
        supportEl?.lastChild.removeChild(supportEl?.lastChild.lastChild);
      }

      supportMoreEl.setAttribute(
        "style",
        `display:flex!important;top:${
          (headerEl?.clientHeight || 82) - 1
        }px!important`
      );
    }
  });
}

// 遮挡层
function stopShelterEl() {
  const shelterEl = document.querySelector(".search-modal .modal-overlay");
  shelterEl.addEventListener("click", function (event) {
    event.stopPropagation();
  });
}

// 搜索栏
function initSearchEvt() {
  const openSearchEl = document.querySelector(".gradient");
  const searchEl = document.querySelector(".header__icons .header__search");
  const openEl = searchEl.children;
  const navEl = document.querySelector(".header__inline-menu");

  searchEl.addEventListener("click", function () {
    if (
      openEl[0].open &&
      openSearchEl.className.indexOf("overflow-hidden") != -1
    ) {
      navEl.style.display = "none";
    } else {
      navEl.style.display = "block";
    }
  });
}

function hoverClassify(e) {
  let classifyEl = e.target;

  const headerEl = document.getElementById("shopify-section-header");
  const classifyElMoreEl = classifyEl?.children?.[1];

  if (classifyElMoreEl) {
    classifyElMoreEl
      .getElementsByClassName("tmenu-watermark")[0]
      ?.setAttribute("style", `display:none !important;`);

    classifyElMoreEl.setAttribute(
      "style",
      `${classifyElMoreEl?.getAttribute("style")};top:${
        (headerEl?.clientHeight || 82) - 1
      }px !important;`
    );
    //移除事件
    classifyEl?.addEventListener("mouseleave", () => {
      classifyEl?.removeEventListener("mouseenter", hoverClassify);
    });
  }

  toggleLiActive(classifyElMoreEl, 0);
  Array.from(classifyElMoreEl?.children)?.forEach((el) => {
    el.addEventListener("mouseenter", (e) => {
      toggleLiActive(classifyElMoreEl);
      e?.target && (e.target.className = e.target.className + " active");
    });
  });
  //切换状态，默认清除
  function toggleLiActive(pEL, activeIdx) {
    let { children } = pEL;
    Array.from(pEL.children)?.map((el, i) => {
      if (activeIdx === i) {
        el.className = el.className + " active";
      } else {
        el.className = el.className.replace(" active", "");
      }
    });
  }
}

// 遮挡层
function stopShelterEl() {
  const shelterEl = document.querySelector(".search-modal .modal-overlay");
  shelterEl.addEventListener("click", function (event) {
    event.stopPropagation();
  });
}

// 搜索栏
function initSearchEvt() {
  const openSearchEl = document.querySelector(".gradient");
  const searchEl = document.querySelector(".header__icons .header__search");
  const openEl = searchEl.children;
  const navEl = document.querySelector(".header__inline-menu");

  searchEl.addEventListener("click", function () {
    if (
      openEl[0].open &&
      openSearchEl.className.indexOf("overflow-hidden") != -1
    ) {
      navEl.style.display = "none";
    } else {
      navEl.style.display = "block";
    }
  });
}

// start 活动定时器
function initCountDown(countDownEl) {
  let activityShowTime = countDownEl.getAttribute("data-show-time");
  let activityEndTime = countDownEl.getAttribute("data-end-time");

  //del
  // activityShowTime = "2023/11/22 18:50:00";
  // activityEndTime = "2023/12/23 14:45:00";
  //end del
  const countDayEl = countDownEl.getElementsByClassName("count-down-days")[0];
  const countHourEl = countDownEl.getElementsByClassName("count-down-hours")[0];
  const countMinuteEl =
    countDownEl.getElementsByClassName("count-down-minutes")[0];
  const countSecondEl =
    countDownEl.getElementsByClassName("count-down-seconds")[0];
  const nowTime = new Date().getTime();

  if (
    !activityEndTime ||
    !activityShowTime ||
    nowTime > new Date(activityEndTime).getTime() ||
    nowTime < new Date(activityShowTime).getTime()
  ) {
    countDownEl.style.display = "none";
  } else {
    countDownEl.style.display = "flex";

    start({
      countDownEl: countDownEl,
      showTime: activityShowTime,
      endTime: activityEndTime,
      dayEl: countDayEl,
      hourEl: countHourEl,
      minuteEl: countMinuteEl,
      secondEl: countSecondEl,
    });
  }
}
function start({
  countDownEl,
  showTime,
  endTime,
  dayEl,
  hourEl,
  minuteEl,
  secondEl,
}) {
  let times = 0,
    days,
    hours,
    minutes,
    seconds;

  let timerSecond = setInterval(() => {
    times = Math.round(
      (new Date(endTime).getTime() - new Date().getTime()) / 1000
    );
    if (times < 0) {
      clearInterval(timerSecond);
      countDownEl.style.display = "none";
      return;
    }
    days = Math.floor(times / 60 / 60 / 24);
    hours = Math.floor((times % (60 * 60 * 24)) / 60 / 60);
    minutes = Math.floor((times % 3600) / 60);
    seconds = times % 60;
    if (times > 60 * 60 * 24) {
      if (dayEl.children?.[0]?.children?.length > 1) {
        dayEl.children[0].children[0].innerText = addZero(days);
        dayEl.children[0].children[1].innerText = addZero(
          days === 0 ? days : days - 1
        );
      }
    }
    if (times > 60 * 60) {
      if (hourEl.children?.[0]?.children?.length > 1) {
        hourEl.children[0].children[0].innerText = addZero(hours);
        hourEl.children[0].children[1].innerText = addZero(
          hours === 0 ? 23 : hours - 1
        );
      }
    }
    if (times > 60) {
      if (minuteEl.children?.[0]?.children?.length > 1) {
        minuteEl.children[0].children[0].innerText = addZero(minutes);
        minuteEl.children[0].children[1].innerText = addZero(
          minutes === 0 ? 59 : minutes - 1
        );
      }
    }
    if (secondEl.children?.[0]?.children?.length > 1) {
      secondEl.children[0].children[0].innerText = addZero(seconds);
      secondEl.children[0].children[1].innerText = addZero(
        seconds === 0 ? 59 : seconds - 1
      );
    }
    let dayNumberEls = dayEl.children[0].children;
    let hourNumberEls = hourEl.children[0].children;
    let minutesNumberEls = minuteEl.children[0].children;
    let secondNumberEls = secondEl.children[0].children;
    let height = secondNumberEls[0].clientHeight;
    //秒
    let nextSecondEL = document.createElement("span");
    nextSecondEL.innerText = addZero(seconds);
    //分
    minutesNumberEls[0].innerText = addZero(minutes);
    let nextMinuteEl;

    if (seconds === 0 && times > 60) {
      nextMinuteEl = document.createElement("span");
      nextMinuteEl.innerText = addZero(minutes);
    }
    //时
    let nextHourEl;
    if (minutes === 0 && seconds === 0 && times > 60 * 60) {
      nextHourEl = document.createElement("span");
      nextHourEl.innerText = addZero(hours);
    }
    //日
    let nextDayEl;
    if (hours === 0 && minutes === 0 && seconds === 0 && times > 60 * 60 * 24) {
      nextDayEl = document.createElement("span");
      nextDayEl.innerText = addZero(hours);
    }

    let timer = setInterval(() => {
      let styles = `translate(0px, ${height-- - 20}px)`;
      // console.log(height, numberEls);
      if (
        hours === 0 &&
        minutes === 0 &&
        seconds === 0 &&
        times >= 60 * 60 * 24
      ) {
        dayNumberEls[0].style.transform = styles;
        dayNumberEls[1] && (dayNumberEls[1].style.transform = styles);
      }
      if (minutes === 0 && seconds === 0 && times >= 60 * 60) {
        hourNumberEls[0].style.transform = styles;
        hourNumberEls[1] && (hourNumberEls[1].style.transform = styles);
      }
      if (seconds === 0 && times > 60) {
        minutesNumberEls[0].style.transform = styles;
        minutesNumberEls[1] && (minutesNumberEls[1].style.transform = styles);
      }
      if (times > 0) {
        secondNumberEls[0].style.transform = styles;
        secondNumberEls[1].style.transform = styles;
      }
      if (height <= 0) {
        clearInterval(timer);
        if (times) {
          secondNumberEls[1].style.transform = `translate(0px,0px)`;
          secondEl.children[0].removeChild(secondNumberEls[0]);
          secondEl.children[0].appendChild(nextSecondEL);
        }
        if (
          hours === 0 &&
          minutes === 0 &&
          seconds === 0 &&
          times > 60 * 60 * 24
        ) {
          dayNumberEls[1].style.transform = `translate(0px,0px)`;
          dayEl.children[0].removeChild(dayNumberEls[0]);
          dayEl.children[0].appendChild(nextDayEl);
        }
        if (minutes === 0 && seconds === 0 && times > 60 * 60) {
          hourNumberEls[1].style.transform = `translate(0px,0px)`;
          hourEl.children[0].removeChild(hourNumberEls[0]);
          hourEl.children[0].appendChild(nextHourEl);
        }
        if (seconds === 0 && times > 60) {
          minutesNumberEls[1].style.transform = `translate(0px,0px)`;
          minuteEl.children[0].removeChild(minutesNumberEls[0]);
          minuteEl.children[0].appendChild(nextMinuteEl);
        }
      }
    }, 10);
  }, 1000);
}
function addZero(number) {
  let str = String(number);

  return str.length === 0 ? "00" : str.length === 1 ? `0${str}` : str;
}
// end 活动定时器

// 固定顶部导航栏于顶部
const headerEl = document.querySelector(".header-wrapper");
window.addEventListener("scroll", function () {
  let scrollY = this.document.documentElement.scrollTop;
  if (scrollY > 81) {
    headerEl.classList.add("fixed");
  } else {
    headerEl.classList.remove("fixed");
  }
});

// 监听页面窗口变化
window.onresize = function () {
  resizeFresh();
};

let bodyWidth = window.innerWidth;
function resizeFresh() {
  if (bodyWidth != window.innerWidth) {
    location.reload();
  }
}
